import { EVENT_TYPE, MEDIA } from "@Utils";
import { getRandomInt } from "repoV2/features/Common/modules/Random/Random.utils";
import React, { useState } from "react";
import { IRecentSalesPopup } from "./RecentSalesPopup";
import styles from "./RecentSalesPopup.module.scss";

const RecentSalesPopup = ({
    enabled,
    eventType,
    eventTitle,
    coverImage = MEDIA.DEFAULT.CARD_IMAGE,
}: IRecentSalesPopup.IProps): JSX.Element | null => {
    // values stored in state to avoid rerenders
    // get a random number from 2 to 10
    const [numberOfPeople] = useState(getRandomInt(9) + 2);
    // get a random number from [15, 30, 45, 60]
    const [time] = useState((getRandomInt(4) + 1) * 15);

    let actionText;
    switch (eventType) {
        case EVENT_TYPE.APPOINTMENTS:
        case EVENT_TYPE.WEBINAR:
        case EVENT_TYPE.ONE_ON_ONE_CLASSES:
        case EVENT_TYPE.GROUP_CLASSES:
        case EVENT_TYPE.ROLLING_CLASSES:
        case EVENT_TYPE.WORKSHOPS:
            actionText = "booked";
            break;
        case EVENT_TYPE.NO_SCHEDULE:
        case EVENT_TYPE.RECORDED_CONTENT:
        case EVENT_TYPE.MERCHANDISE:
            actionText = "purchased";
            break;
        default:
            actionText = "purchased";
            break;
    }

    const [showRecentSalesPopup, setShowRecentSalesPopup] =
        useState<boolean>(false);

    const closeRecentSalesPopup = () => {
        setShowRecentSalesPopup(false);
    };

    React.useEffect(() => {
        if (enabled) {
            // popup is displayed for 10 sec
            const duration = 10 * 1000;

            // show popup three times
            const atTimes = [
                0, // 0 is for initialization
                // first at 15 sec
                15 * 1000,
                // and then randomly between 1-3 minute after previous display
                (getRandomInt(3) + 1) * 1000 * 60,
                // and then randomly between 3-5 minute after previous display
                (getRandomInt(3) + 3) * 1000 * 60,
            ];

            for (let i = 1; i <= 3; i += 1) {
                atTimes[i] += atTimes[i - 1];
                setTimeout(() => setShowRecentSalesPopup(true), atTimes[i]);
                atTimes[i] += duration;
                setTimeout(() => setShowRecentSalesPopup(false), atTimes[i]);
            }
        }
    }, []);

    if (!(enabled && showRecentSalesPopup)) return null;

    return (
        <div id="RecentSalesPopupContainer" className={styles.popupContainer}>
            <div className={styles.popup}>
                <img
                    className={styles.image}
                    src={coverImage}
                    alt={eventTitle}
                />
                <div className={styles.textContainer}>
                    <div className={styles.recentlyPurchasedText}>
                        <span
                            className={styles.recentlyPurchasedTextHighligted}
                        >
                            {`${numberOfPeople} new customers`}
                        </span>
                        {`, recently ${actionText}`}
                    </div>
                    <div className={styles.title}>{eventTitle}</div>
                    <div className={styles.timeText}>
                        {`in last ${time} mins`}
                    </div>
                </div>
                <div
                    className={styles.closeButton}
                    onClick={closeRecentSalesPopup}
                >
                    &times;
                </div>
            </div>
        </div>
    );
};
export default RecentSalesPopup;
